import CommonTable from 'components/table/CommonTable';
import styled from 'styled-components';

export const AutomationsStyledTable = styled(CommonTable)`
  margin-bottom: 0;

  tbody {
    tr {
      td {
        height: 40px;
      }
    }
  }

  tfoot {
    tr {
      td {
        padding-bottom: 0;

        .pagination {
          margin: 16px 0;
        }
      }
    }
  }
` as typeof CommonTable;
